import React, { useEffect, useRef } from 'react';
import {
  GameContainer,
  WinVideoElement,
  LoseVideoElement,
  LandingVideoElement,
} from './VideoPlugin.style';

import { BlockInfoType } from '../../common-types/BlockInfo.type';
const delayAfterVideoEnds = 1500;

interface IVideoPluginProps {
  onPluginDone?: () => void;
  hasWon: null | boolean;
  addEditableBlock?: (block: BlockInfoType) => void;
  removeEditableBlock?: (configPath: string) => void;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
  isPlaying: boolean;
  isEdition: boolean;
  onLoad?: () => void;
  winVideo: { mp4: string };
  loseVideo: { mp4: string };
  landingVideo?: { mp4: string };
  VideoWrapper: React.ElementType;
}

export const VideoPlugin: React.FunctionComponent<IVideoPluginProps> = ({
  hasWon,
  onPluginDone,
  addEditableBlock,
  removeEditableBlock,
  onBlockEdit,
  onLoad,
  isEdition,
  landingVideo,
  winVideo,
  loseVideo,
  VideoWrapper,
}) => {
  const loaderTimeout = useRef<NodeJS.Timeout | null>(null);
  const winVideoRef = useRef<HTMLVideoElement>(null);
  const loseVideoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (loaderTimeout.current !== null) {
      clearTimeout(loaderTimeout.current);
    }
    const nextScreen = (): void => {
      setTimeout(() => {
        if (onPluginDone) {
          onPluginDone();
        }
      }, delayAfterVideoEnds);
    };


    const refVideo =
        // eslint-disable-next-line no-nested-ternary
        hasWon === true ? winVideoRef.current :
          hasWon === false ? loseVideoRef.current : null;

    if (refVideo) {
      refVideo.defaultMuted = true;
      refVideo.muted = true;
      refVideo.autoplay = true;
      refVideo.setAttribute('webkit-playsinline', '');
      refVideo.addEventListener('ended', nextScreen);
    }

  }, [hasWon, onPluginDone]);

  return (
    <GameContainer
      onBlockEdit={onBlockEdit}
      dataTemplateType="plugin"
      displayName="plugin"
      dataTemplateConfig="screens.game.plugin"
      isEdition={isEdition}
      addEditableBlock={addEditableBlock}
      removeEditableBlock={removeEditableBlock}
      onLoad={onLoad}
      neededAssets={[]}
    >
      <VideoWrapper>
        {landingVideo !== undefined && landingVideo !== null && 
        <LandingVideoElement> 
          <source src={landingVideo.mp4} type="video/mp4" />
        </LandingVideoElement>
        }        
        {hasWon === true &&
        <WinVideoElement ref={winVideoRef} playsInline muted>
          <source src={winVideo.mp4} type="video/mp4" />
        </WinVideoElement>
        }
        {hasWon === false &&
        <LoseVideoElement ref={loseVideoRef} playsInline muted>
          <source src={loseVideo.mp4} type="video/mp4" />
        </LoseVideoElement>
        }
      </VideoWrapper>
    </GameContainer>
  );
};